import { getWeixinSign } from "@/api/index.js";

/**
 * 微信分享签名生成添加定时器节流
 */
let timer = null;
export function wxConfigInitThrottle() {
  let trottle = false;
  clearTimeout(timer);
  timer = setTimeout(() => {
    trottle = true;
    if (trottle) {
      wxConfigInit();
    }  
  }, 1000);
}

function wxConfigInit() {
  let shareUrl = window.location.href;

  getWeixinSign({ url: shareUrl }).then(function (res) {

    let result = res && res.data;

    // 微信配置
    wx.config({
      beta: true,
      // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      debug: false,    
      appId: "wx491440843c14d31a",  // 必填，公众号的唯一标识
      timestamp: result.timestamp,    // 必填，生成签名的时间戳
      nonceStr: result.nonceStr,   // 必填，生成签名的随机串
      signature: result.signature,  // 必填，签名
      jsApiList: [
        // 'updateAppMessageShareData',
        // 'updateTimelineShareData',
        'onMenuShareAppMessage',
        'onMenuShareQQ',
        'onMenuShareTimeline',
        'onMenuShareQZone',
        'onMenuShareWeibo'
      ]   // 必填，需要使用的JS接口列表
    });

    // 配置成功
    wx.ready(() => {

      let details = { 
        title: '万店掌体验中心', // 分享标题
        desc: '连锁门店标准化一站式服务平台，快进来体验吧！', // 分享描述
        // link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wdz-wx_logo_20220304.png", // 分享图标
        success: function () {
          // 设置成功
          // console.log(63, "微信分享配置成功");
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
          // console.log(63, "用户取消");
        }
      };
      // 自定义分享给朋友及QQ
      // wx.updateAppMessageShareData(details);
      // 自定义分享到朋友圈及QQ空间
      // wx.updateTimelineShareData(details);
      // 微信好友
      wx.onMenuShareAppMessage(details);
      // QQ好友
      wx.onMenuShareQQ(details);
      // 朋友圈
      wx.onMenuShareTimeline(details);
      // QQ空间
      wx.onMenuShareQZone(details);
      // 腾讯微博
      wx.onMenuShareWeibo(details);
    });

    wx.error(function(res){
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      console.log("error: ", res);
    });

  })
}
